module.exports = __webpack_public_path__ + "static/media/trophy_white.a4005aaa.svg";